import React, { useEffect } from "react";
import TopBar from "../components/aa/TopBar";
import Hero from "../components/aa/Hero";
import ChipsBand from "../components/aa/ChipsBand";
import Benefits from "../components/aa/Benefits";
import Audience from "../components/aa/Audience";
import Marketing from "../components/aa/Marketing";
import Steps from "../components/aa/Steps";
import Plans from "../components/aa/Plans";
import FAQ from "../components/aa/FAQ";
import Footer from "../components/aa/Footer";

export default function LandingPage() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[var(--aa-cream)] text-[var(--aa-ink)] font-body">
      <TopBar />
      <Hero />
      <ChipsBand />
      <Benefits />
      <Audience />
      <Marketing />
      <Steps />
      <Plans />
      <FAQ />
      <Footer />
    </div>
  );
}
